import { ClienteVendaResumoSecao } from '../../../../../../../types/cliente-venda';
import { CollapsibleSection } from '../../produtos/sections/collapsible-section';
import { formatPreco, simNao } from '../format';
import { Row } from './styles';

interface Props {
  vendaId: string;
  createdAtIso: string;
  data: ClienteVendaResumoSecao;
}

const formatDateTime = (iso: string | null): string => {
  if (!iso) return '—';
  try {
    return new Intl.DateTimeFormat('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const ResumoSection = ({ vendaId, createdAtIso, data }: Props) => (
  <CollapsibleSection
    title="Resumo"
    defaultOpen
    testId="venda-section-resumo"
  >
    <Row>
      <span>ID</span>
      <span>{vendaId}</span>
    </Row>
    <Row>
      <span>Data</span>
      <span>{formatDateTime(createdAtIso)}</span>
    </Row>
    <Row>
      <span>Status</span>
      <span>{data.statusDescricao ?? '—'}</span>
    </Row>
    <Row>
      <span>Valor pago</span>
      <span>{formatPreco(data.valorPago, data.moedaSigla)}</span>
    </Row>
    <Row>
      <span>Método de pagamento</span>
      <span>{data.metodoPagamentoDescricao ?? '—'}</span>
    </Row>
    <Row>
      <span>Gateway</span>
      <span>{data.gatewayDescricao ?? '—'}</span>
    </Row>
    <Row>
      <span>Tipo da venda</span>
      <span>{data.tipoVenda}</span>
    </Row>
    {data.vendaParceiroId && (
      <Row>
        <span>Venda parceira (origem)</span>
        <span>{data.vendaParceiroId}</span>
      </Row>
    )}
    {data.transacaoGatewayId && (
      <Row>
        <span>ID transação gateway</span>
        <span>{data.transacaoGatewayId}</span>
      </Row>
    )}
    <Row>
      <span>Recebíveis OK</span>
      <span>{simNao(data.recebiveisOk)}</span>
    </Row>
    <Row>
      <span>Chargeback global</span>
      <span>{simNao(data.handledByGlobalChargeback)}</span>
    </Row>
    {data.reconcileStatus != null && (
      <Row>
        <span>Status reconciliação</span>
        <span>{data.reconcileStatus}</span>
      </Row>
    )}
  </CollapsibleSection>
);
